import request from "@/utils/request";

// 获取平台增效数值
export function addConsult(params) {
  return request({
    url: "/pt/consult/addConsult",
    method: "POST",
    params
  });
}

export function listSchedule(params) {
  return request({
    url: "/pt/co/cotenet/list",
    method: "get",
    params
  })
}

export function addSchedule(params) {
  return request({
    url: '/pt/co/cotent/add',
    method: 'post',
    data: params
  })
}

export function delScheduleById(id) {
  return request({
    url: '/pt/co/content/cancel/' + id,
    method: 'delete'
  })
}

export function getConsultList(params) {
  return request({
    url: "/jz/article/api/v1/list",
    method: "get",
    params
  });
}

export function getConsultInfo(id) {
  return request({
    url: "/jz/article/api/v1/get/" + id,
    method: "get"
  });
}

// 附件下载 意见反馈
export function saveOperLog(params) {
  return request({
    url: "/jz/article/saveOperLog",
    method: "POST",
    data: params
  });
}

// 白皮书文件下载
export function downloadFile(bucketName, key) {
  return request({
    url: `/jz/file/download/${bucketName}/${key}`,
    method: "get"
  });
}

// 日程详情
export function contentDetail(id) {
  return request({
    url: '/pt/co/content/'+id,
    method: 'get',
  })
}
// 日程确认完成
export function completeDetail(params) {
  return request({
    url: '/pt/co/content',
    method: 'put',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/consult.js